import {fetchItems} from "@/store/api/api";

export default {
    namespaced: true,
    state: {
        id: null,
        items: [],
    },
    getters: {
        getCurrentItem: (state) =>
            state.items.find(item => item.id === state.id),
        isItemExist: (state) => (id) =>
            state.items.some(items => items.id === id)
    },
    mutations: {
        setItems(state, payload) {
            state.items = payload;
        },
        setCurrentItem(state, payload) {
            state.id = parseInt(payload);
        },
        clearItem(state) {
            state.id = null;
        },
    },
    actions: {
        async fetchItems({commit}, options) {
            const items = await fetchItems(options);
            commit('setItems', items);
        },
        setCurrentItem({commit, dispatch}, id) {
            commit('setCurrentItem', id);
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearItem({commit, dispatch}) {
            commit('clearItem');
            dispatch('clearItemDependencies');
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        clearItemDependencies({dispatch}) {
            dispatch('variation/clearVariation', null, {root: true});
        }
    }
}
